
import styled from "styled-components";
import { naira } from "../../../utils/data";
import { Input } from "../../../styles";
import MiniLoader from "../../../utils/MIniLoader";
import { th } from "../../../utils/helpers";
import { useReportContext } from "../../../context/report_context";


const BestSellingProduct = ({ storeBestSell }) => {

      const { isFetching, } = useReportContext();


      return (
            <StyledBestSellingProduct className="h-100">
                  <div className="main-container">
                        <div className="justify-content-between row">

                              <div className="d-flex gap-2">
                                    <h4 className="grey-bold-text">
                                          Best Selling Product
                                    </h4>
                                    <MiniLoader
                                          load={isFetching}
                                    />
                              </div>
                        </div>


                        <div className="light-bg br-md">

                              <div className="table-responsive">
                                    <table className='table p-2 border-0 text-center text-nowrap br-md fs-6' >
                                          <thead>
                                                <tr className=''>
                                                      <th scope="col" className='text-start grey-text'>
                                                            Product
                                                      </th>
                                                      <th scope="col" className='text-start grey-text'>
                                                            Product ID
                                                      </th>
                                                      <th scope="col" className='grey-text'>
                                                            Amount
                                                      </th>
                                                </tr>
                                          </thead>

                                          <tbody>
                                                {storeBestSell && storeBestSell.length > 0 ? (
                                                      storeBestSell.map(({ name = 'Name', item_id, amount }, i) => (
                                                            <tr className='py-2' key={i}>
                                                                  <td className="text-start">{name}</td>
                                                                  <td>{item_id}</td>
                                                                  <td>{naira}{th(amount)}</td>
                                                            </tr>
                                                      ))
                                                ) : (
                                                      <tr>
                                                            <td colSpan={3} className="py-4 text-center">
                                                                  No items
                                                            </td>
                                                      </tr>
                                                )}

                                          </tbody>
                                    </table>
                              </div>
                        </div>
                  </div>


            </StyledBestSellingProduct>
      );
};

export default BestSellingProduct;

const StyledBestSellingProduct = styled.div`
      

      input.month-input {
            border-radius: 0px !important;
            padding: 4px 4px;
            border-color: #a8a5a5;
      }


`;